import React from 'react';
import { FormGroup, Label, Input,Col, Row } from 'reactstrap';
import '../FormsTypeAnalytes/RangeFormStyele.css';

export const RangeForm = (props) => {
    const {
        activeTab, isSimple, id_type_analyte, replace,
        handleInputChange, handleFullModal, modalFullRef, handleResetComplexAnalyte, analyteId
    } = props;

    const isTypeSeven = id_type_analyte === "7";

    return (
        <>
            <Col xs="12" sm={isSimple ? "3" : "12"} md={isSimple ? "3" : "12"} lg={isSimple ? "3" : "12"} xl={isSimple ? "3" : "12"}>
            <FormGroup className={`mb-3  ${(id_type_analyte === "4" || id_type_analyte === "5") ? "" : "d-none"}`}>
                <Label className="text-sm">Reemplazar</Label>
                <Input
                    className="form-control form-control-sm input-air-primary" 
                    disabled={activeTab === 2}
                    bsSize="sm"
                    type="select"
                    name="replace"
                    value={replace}
                    onChange={handleInputChange}
                    required={true}
                >
                    <option value={false}>No</option>
                    <option value={true}>Si</option>
                </Input>
            </FormGroup>
            </Col>

              
            <FormGroup className={`text-right mb-2 col-12 ${(id_type_analyte === "1" || id_type_analyte === "2" || id_type_analyte === "3" || id_type_analyte === "4" || id_type_analyte === "5" || id_type_analyte === "6") ? "" : "d-none"}`}>
                <span style={{ cursor: "pointer" }} className="link text-sm text-primary badge badge-light-primary f-12" ref={modalFullRef} onClick={() => handleFullModal("modalRangos")}>Valores de referencia</span>
            </FormGroup>

            {isTypeSeven && (
                <FormGroup className="col-12">
                    <div className="d-flex justify-content-between align-items-center gap-2">

                        <span
                            className="link badge badge-light-danger span-fit"
                            onClick={() => handleResetComplexAnalyte(analyteId)}
                        >
                            Limpiar Fórmula
                        </span>

                        <span
                            className="link badge badge-light-info span-fit"
                            onClick={() => handleFullModal("modalComplex")}
                        >
                            Gestionar Fórmula
                        </span>

                        <span
                            className="link badge badge-light-primary span-fit"
                            ref={modalFullRef}
                            onClick={() => handleFullModal("modalRangos")}
                        >
                            Valores de referencia
                        </span>

                    </div>
                </FormGroup> 
            )}

           



        
 
        </>
    )
}
